import React, { useState, useRef, useEffect } from "react";
import "./NotesBox.css";
import { useTranslation } from "react-i18next";
import "./InputBox.css";
const NotesBox = ({
  label,
  defaultValue = "",
  value: propValue,
  onChange,
  validators = [],
  name,
  isRequired = false,
  error,
  className = "",
  border = "",
  readOnly = false,
  maxChar = null,
  size = "large",
  height = "",
  important = false,
  useAddLabel = false,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(propValue !== undefined ? propValue : defaultValue);
  const [errors, setErrors] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const textareaRef = useRef(null);

  const validatorArray = Array.isArray(validators)
    ? validators
    : validators
      ? [validators]
      : [];

  const effectiveValidators = isRequired
    ? [
        ...(typeof validatorArray === "function"
          ? [validatorArray]
          : validatorArray),
        (val) =>
          (val !== null && val !== undefined && val !== "") ||
          "This field is required",
      ]
    : validatorArray;

  const validateInput = (inputValue) => {
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === "function") {
          const result = validator(inputValue);
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === "string");

    return newErrors;
  };

  useEffect(() => {
    if (propValue !== undefined) {
      setValue(propValue);
    } else {
      setValue(defaultValue);
    }
  }, [defaultValue, propValue]);

  const handleInputChange = (event) => {
    let newValue = event.target.value;

    if (maxChar) {
      newValue = newValue.slice(0, maxChar);
    }

    const newErrors = validateInput(newValue);

    setValue(newValue);
    setErrors(newErrors);

    if (onChange) {
      const modifiedEvent = {
        ...event,
        target: {
          ...event.target,
          value: newValue,
        },
      };
      onChange(modifiedEvent);
    }
  };

  const handleExpand = () => {
    setIsExpanded(true);
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }, 0);
  };

  const displayErrors = error ? [error] : errors;

  const activeValue = propValue !== undefined ? propValue : value;

  const noteExists = Boolean(
    activeValue !== null &&
      activeValue !== undefined &&
      String(activeValue).trim() !== "" &&
      String(activeValue).trim() !== "-"
  );

  if (useAddLabel && readOnly && !noteExists) {
    return null;
  }

  const shouldShowTextBox =
    !useAddLabel ||
    isRequired ||
    important ||
    isExpanded ||
    noteExists ||
    displayErrors.length > 0;

  // Determine container class based on size
  const containerClass =
    size === "small"
      ? "small-notes-box-container"
      : "large-notes-box-container";

  const displayLabel = label || "Notes";
  const addLabel = displayLabel.toLowerCase().startsWith("add ")
    ? displayLabel
    : `Add ${displayLabel}`;

  if (!shouldShowTextBox) {
    return (
      <div className={`notes-box-container ${containerClass} ${className}`}>
        <div className="add-notes-trigger" onClick={handleExpand}>
          <span className="add-notes-text-label common-text ">{t(addLabel)}</span>
          <svg
            className="plus-icon"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7.5" cy="8.21436" r="7.5" fill="#DFA226" />
            <path
              d="M10.1284 8.64655H7.96415V10.8644H6.82843V8.64655H4.66415V7.61798H6.82843V5.40012H7.96415V7.61798H10.1284V8.64655Z"
              fill="white"
            />
          </svg>
          {important && <span className="required-asterisk">*</span>}
        </div>
      </div>
    );
  }

  const currentValueDisplay = activeValue ?? "";

  return (
    <div className={`notes-box-container ${containerClass} ${className}`}>
      <textarea
        ref={textareaRef}
        className={`notes-textarea ftw-4 ${displayErrors.length > 0 ? "input-error" : ""} ${border} ${height}`}
        value={currentValueDisplay}
        onChange={handleInputChange}
        placeholder=""
        name={name}
        readOnly={readOnly}
      />
      <label className={`notes-label ${currentValueDisplay ? "has-value" : ""}`}>
        {t(label)}
        {important && <span className="required-asterisk">*</span>}
      </label>
      {/* {displayErrors.length > 0 && (
        <div className="input-error-message notes-error-message common-text  red">
          {displayErrors[0]}
        </div>
      )} */}
    </div>
  );
};

export const AddNoteButton = ({ onClick, label = "Add Note", className = "" }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={`add-note-btn ${className}`}
      onClick={onClick}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 3.33334V12.6667"
          stroke="#094c80"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 8H12.6673"
          stroke="#094c80"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{t(label)}</span>
    </button>
  );
};

export default NotesBox;


